import React from 'react'
import _ from "underscore";

// Math, math, math

const Math = function(props) {
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id}/>);
    
    if (childBlocks.length > 0) {
        return (
            <category name='Math' id='math' iconclass='category with-icon-paths snap-icon-maths_dual'>
                <label text="Math"/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default Math;